import { ApiClient } from "client/base";
export class CloudViewClient extends ApiClient {
    getPrediction(id, model_id, payload) {
        return this.base.post(`views/${id}/models/${model_id}/predict`, payload);
    }
}
